import React from 'react';
import Grid from '@techsoftware/happay-widgets/Grid';
import Button from '@techsoftware/happay-widgets/Button';
import Icons from '@techsoftware/happay-widgets/FontIcon';
import Table from '@techsoftware/happay-widgets/Table';
import Pagination from '@techsoftware/happay-widgets/Pagination';
import BottomActions from '../bottomActions';
import PropTypes from 'prop-types';
import Popup from '@techsoftware/happay-widgets/Popup';
export default class VendorsPreview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      pageSize: 50,
      showErrorPopup: false,
    };
  }
  handleSubmit = val => {
    const { handleDownloadTemplate, file } = this.props;
    handleDownloadTemplate(val);
  };
  handlePageChange = (currentPage, pageSize = 50) => {
    this.setState({ currentPage, pageSize });
  };
  handleErrorPopup = () => {
    this.setState(prevState => ({
      showErrorPopup: !prevState.showErrorPopup,
    }));
  };
  handleErrorPopupOpen = () => {
    this.setState({ showErrorPopup: true });
  };
  handleErrorPopupClose = () => {
    this.setState({ showErrorPopup: false });
  };
  returnStepperContent2UI = (
    currentPage,
    pageSize,
    start,
    end,
    bulkXlData,
    columns,
    errorRes,
    showErrorPopup,
  ) => {
    const {
      duplicate_gstin = [],
      duplicate_pan = [],
      show_preview,
      limit,
    } = errorRes;

    let duplicateRows = [];
    let noDuplicateRows = [];
    bulkXlData?.[0]?.data.forEach(item => {
      if (
        [...duplicate_gstin, ...duplicate_pan].some(item1 =>
          [item?.GSTIN, item?.PAN].includes(item1),
        )
      ) {
        duplicateRows.push({ ...item, isDuplicate: true });
      }
    });
    bulkXlData?.[0]?.data.forEach(item => {
      if (
        ![...duplicate_gstin, ...duplicate_pan].some(item1 =>
          [item?.GSTIN, item?.PAN].includes(item1),
        )
      ) {
        noDuplicateRows.push({ ...item, isDuplicate: false });
      }
    });
    const newData = [...duplicateRows, ...noDuplicateRows];
    const noOfErrors = [...duplicate_gstin, ...duplicate_pan].length;

    return (
      <Grid item container xs={24} sm={24} md={24} lg={24} xl={24}>
        <Grid
          container
          xs={24}
          sm={24}
          md={24}
          lg={24}
          xl={24}
          className={`white-bg primary-dark-color`}
        >
          <Grid
            item
            xs={24}
            sm={24}
            md={24}
            lg={24}
            xl={24}
            className="padding-b-20 white-bg fw-600 font-16 dark-blue-grey font-family-cncl fw-500"
          >
            <Grid
              item
              className={' padding-lr-30 padding-b-20 border-bottom font-14'}
            >
              Preview File
              {noOfErrors ? (
                <Grid
                  item
                  className={'float-right fw-400 alert-red-color d-flex'}
                >
                  <div>{noOfErrors} errors found</div>
                  <Popup
                    id="scrolling-popup-top-center"
                    parentElementId="physical-info"
                    open={showErrorPopup}
                    pointerPlacement="top-right"
                    popupStyle={{
                      right: -5,
                      height: 67,
                      width: 'fit-content',
                      blockSize: 'fit-content',
                    }}
                    // onClose={eve => this.handleErrorPopup(eve)}
                    variant="scroll"
                    borderStyle="1px solid #eb4646"
                    onMouseEnter={this.handleErrorPopupOpen}
                    onMouseLeave={this.handleErrorPopupClose}
                    parentElement={
                      <Icons
                        id="physical-info"
                        type="info"
                        size="small"
                        onClick={this.handleErrorPopup}
                        interactive
                        color={'#eb4646'}
                      />
                    }
                  >
                    <div className="padding-10 font-12 dark-text fw-400 width-210 ">
                      {duplicate_gstin &&
                        `Duplicate GSTIN: ${duplicate_gstin.length} errors found `}
                      <br />
                      {duplicate_gstin &&
                        `Duplicate PAN: ${duplicate_pan.length} errors found `}
                    </div>
                  </Popup>
                </Grid>
              ) : (
                ''
              )}
              <Grid item className={'padding-t-10  font-12 fw-400 light-black'}>
                You can preview your vendors here before submitting them.
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={24}
            sm={24}
            md={24}
            lg={24}
            xl={24}
            className=" white-bg fw-500 font-14 dark-blue-grey flex-d-column d-flex align-item-baseline-imp overflow-auto"
          >
            <Grid item className={'padding-b-20 padding-l-30'}>
              <Pagination
                currentPage={currentPage}
                totalDataSize={bulkXlData?.[0]?.data?.length}
                sizePerPage={pageSize}
                onPageChange={this.handlePageChange}
              />
            </Grid>
            <div className="vendor-table">
              <Table
                id="bulk-vendor-table"
                customTableOuterStyle={{
                  height: 500,
                  marginTop: 10,
                  border: 'unset',
                  borderTop: '1px solid #E0E0E0',
                  borderRadius: '0px',
                }}
                isDataFetched
                staticRendering
                data={
                  Object.keys(errorRes).length > 0
                    ? newData
                    : bulkXlData?.[0]?.data
                }
                // data={bulkXlData?.[0]?.data}
                columns={columns}
                selectRows={false}
                localPagination={true}
                currentPage={currentPage}
                sizePerPage={pageSize}
              />
            </div>
          </Grid>
          <BottomActions
            {...this.props}
            handleActionClick={val => this.handleSubmit(val)}
            from="Bulk Vendors"
            // validation={true}
            actionMap={{ Submit: 'Submit' }}
            showCancelConfirmation={true}
            disabled={show_preview}
          />
        </Grid>
      </Grid>
    );
  };

  render() {
    const { bulkXlData, errorRes = {} } = this.props;
    const {
      duplicate_gstin = [],
      duplicate_pan = [],
      show_preview,
      limit,
    } = errorRes;
    const columns = bulkXlData?.[0]?.headers.map(item => {
      return {
        // id: item,
        Header: item,
        dataField: item,
        disableDragDrop: false,
        handleAsyncSearch: this.handleAsyncSearch,
        width: 190,
        className: 'padding-0-imp overflow-visible',
        Cell: (cell, col, row, key) => {
          const isDuplicateCell = [
            ...duplicate_gstin,
            ...duplicate_pan,
          ].includes(cell);
          const duplicateCellTooltipText = row?.isDuplicate
            ? duplicate_pan.includes(cell)
              ? 'Duplicate PAN'
              : duplicate_gstin.includes(cell)
              ? 'Duplicate GSTIN'
              : null
            : null;
          return (
            <div
              className={`
              font-14 fw-400 height-54
        ${row?.isDuplicate ? 'light-red padding-18' : 'padding-18 light-black'}
        ${isDuplicateCell ? 'alert-red-color' : ''}
        flex-vertical-center
        `}
            >
              <div
                className={`${
                  cell.length > 24
                    ? 'hw-tooltip table-tooltip long-text-tooltip'
                    : ''
                }
              ${!row?.isDuplicate ? 'dark-border' : ''}`}
                data-tooltip={cell}
              >
                {cell || '\xa0\xa0\xa0\xa0\xa0\xa0\xa0'}
              </div>
              {isDuplicateCell && (
                <div
                  className="pointer hw-tooltip red hw-bottom margin-l-8 table-tooltip"
                  data-tooltip={duplicateCellTooltipText}
                >
                  <Icons
                    id="physical-info"
                    type="info"
                    size="small"
                    className="table-info-icon"
                  />
                </div>
              )}
            </div>
          );
        },
      };
    });

    const { currentPage, pageSize, showErrorPopup } = this.state;
    const start = (currentPage - 1) * pageSize;
    const end = start + pageSize;

    return this.returnStepperContent2UI(
      currentPage,
      pageSize,
      start,
      end,
      bulkXlData,
      columns,
      errorRes,
      showErrorPopup,
    );
  }
}
VendorsPreview.propTypes = {
  bulkXlData: PropTypes.array,
  handleDownloadTemplate: PropTypes.func,
  handleCancel: PropTypes.func,
};

VendorsPreview.defaultProps = {
  bulkXlData: [],
  handleDownloadTemplate: () => {},
  handleCancel: () => {},
};
